import { createContext, useEffect, useState } from "react";
import { webAuth } from "../../utils/userJourneyHelper";
import auth0 from "auth0-js";
import Loader from "../Common/Loader";
import { logout } from "../../utils/userJourneyHelper";
import { useNavigate } from "react-router-dom";

export const getUser = () =>
  new Promise((resolve, reject) => {
    webAuth.checkSession({}, (err, session) => {
      if (err) return reject(err);
      if (!session) return reject("User not found");

      // Get the user data
      const auth0Manage = new auth0.Management({
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        token: session.accessToken,
      });
      const userId = session.idTokenPayload.sub;
      if (!userId) return reject("Invalid session");
      auth0Manage.getUser(userId, (err, profile) => {
        if (err) return reject(err);
        resolve({
          session,
          profile,
        });
      });
    });
  });

export const AuthContext = createContext({});

export function AuthContextProvider({ children }) {
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = async () => {
      setLoading(true);

      const publicPages = [
        "/auth/login",
        "/auth/register",
        "/auth/forgotpassword",
      ];
      const ignoreAuthPages = ["/disclaimer"];
      const path = window.location.pathname.toLowerCase();
      const isMobileRoute = window.location.pathname.startsWith('/mobile');

      const publicPage = publicPages.some((p) => path.startsWith(p));
      const ignoreAuthPage = ignoreAuthPages.some((p) => path.startsWith(p));

      // Get the user details and handle redirects based on if he is authenticated or not
      try {
        const user = await getUser();
        window._accessToken = user?.session?.accessToken;

        // Remember me / Session
        const now = new Date().getTime();
        const rememberMe = localStorage.getItem("remember_me");
        const session = localStorage.getItem("session");
        if (
          (rememberMe && rememberMe < now) ||
          (!rememberMe && session < now)
        ) {
          if (!publicPage && !ignoreAuthPage) {
            if (window.location.pathname !== "/") {
              // Store the current URL for redirect after login
              // For mobile users, store the mobile equivalent of current route
              let urlToStore = window.location.href;

              if (isMobileRoute) {
                const { getMobileRoute } = require("../../utils/mobileDetection");
                const currentPath = window.location.pathname + window.location.search;
                const mobileEquivalent = getMobileRoute(currentPath);
                urlToStore = window.location.origin + mobileEquivalent;
              }
              sessionStorage.setItem("logout_url", urlToStore);
            }
            
          }
          setLoading(false);
          return logout();
        }

        setUser(user);

        const logoutUrl = sessionStorage.getItem("logout_url");
        if (user && logoutUrl && !publicPages.includes(logoutUrl)) {
          sessionStorage.removeItem("logout_url");
          navigate(logoutUrl);
          setLoading(false);
          return;
        }
        if (window.location.pathname.toLowerCase().startsWith("/auth")) {
          navigate("/");
          setLoading(false);
          return;
        }
      } catch (e) {
        console.log("User session / profile not found", e);

        if (!publicPage && !ignoreAuthPage) {
          const redirectUrl = window.location.pathname + window.location.search
          if (window.location.pathname !== "/")
            sessionStorage.setItem("logout_url", redirectUrl);

          if (isMobileRoute) {
            const { getMobileRoute } = require('../../utils/mobileDetection');
            const mobileRedirectPath = getMobileRoute(redirectUrl);
            navigate(mobileRedirectPath, { replace: true });
          } else {
            navigate(redirectUrl);
          }
          navigate("/Auth/Login");
          setLoading(false);
          return;
        }
        setUser(false);
        setLoading(false);
      }

      setLoading(false);
    };
    handler();
  }, []);

  return (
    <AuthContext.Provider
      value={{ user: [user, setUser], loading: [loading, setLoading] }}
    >
      {loading ? <Loader /> : children}
    </AuthContext.Provider>
  );
}
